/**
 * Money helpers. Gravun stores ALL monetary values as integer cents
 * (bigint in Postgres), never floats. Convert at the UI boundary only.
 */

export const formatCents = (
  cents: number | null | undefined,
  currency = "USD",
): string => {
  if (cents == null) return ", ";
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
  }).format(cents / 100);
};

/** Parse a user-entered dollar amount into integer cents (round-half-up). */
export const dollarsToCents = (dollars: number | string): number => {
  const n = typeof dollars === "string" ? Number(dollars) : dollars;
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100);
};

export const centsToDollars = (cents: number | null | undefined): number =>
  cents == null ? 0 : cents / 100;
